import { useState } from 'react';

import { Optional } from 'chaika-frontend-types/frontend-cms';

import { DateHelper } from '@utils/DateHelper';
import { DatePickerNames } from '../constants';

export function useDateParamsState() {
    const [dateParams, setDateParams] = useState({
        from: DateHelper.getStartOfDay(DateHelper.subDays(new Date(), 1)),
        to: DateHelper.getEndOfDay(),
    });

    const maxDate = new Date();

    function onChangePeriod(date: Date, name: string): void {
        setDateParams(current => {
            const period = { ...current };

            if (name === DatePickerNames.To) {
                period.to = DateHelper.getEndOfDay(date);

                if (period.to < period.from) {
                    period.from = DateHelper.getStartOfDay(period.to);
                }
            } else {
                period.from = DateHelper.getStartOfDay(date);

                if (period.from > period.to) {
                    period.to = DateHelper.getEndOfDay(period.from);
                }
            }

            return period;
        });
    }

    function getOpenToDate(): Optional<Date> {
        const { from } = dateParams;

        return !maxDate || !DateHelper.isSameMonth(from, maxDate)
            ? DateHelper.startOfMonth(DateHelper.addMonths(from, 1))
            : undefined;
    }

    return {
        dateParams,
        maxDate,
        onChangePeriod,
        openToDate: getOpenToDate(),
    };
}
